import React, { useEffect } from "react";
import './solu.css'
import { Link } from "react-router-dom";

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import Footer from "../footer";

// IMAGE
import soluimg1 from "../IMAGES-ADHIBA/HOLISTICSECURITY/SOLUIMG1.png"
import soluimg2 from "../IMAGES-ADHIBA/HOLISTICSECURITY/SOLUIMG2.png"
import soluimg3 from "../IMAGES-ADHIBA/HOLISTICSECURITY/SOLUIMG3.png"
import soluimg4 from "../IMAGES-ADHIBA/HOLISTICSECURITY/SOLUIMG4.png"
import soluimg5 from "../IMAGES-ADHIBA/HOLISTICSECURITY/SOLUIMG5.png"
import soluimg6 from "../IMAGES-ADHIBA/HOLISTICSECURITY/SOLUIMG6.png"
import soluimg7 from "../IMAGES-ADHIBA/HOLISTICSECURITY/SOLUIMG7.png"
import soluimg8 from "../IMAGES-ADHIBA/HOLISTICSECURITY/SOLUIMG8.png"
import Testimonial from "../TESTIMONIALS/adhibatesti";

export default function Solutionadhiba() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>

            <section className="">
                <div className="">
                    <img src={soluimg1} className="img-fluid w-100 rounded-0" />
                </div>
            </section>


            {/* INDUSTRY SOLUTIONS */}
            <div className="container solution-contents-adhiba">


                <div className="row">
                    <div className="col-lg-6">
                        <div style={{ marginBottom: "2.5%" }}>
                            <img src={soluimg2} className="img-fluid w-100 rounded-2 left-right-images-adhiba" />
                        </div>
                        <div className="down-contents-adhiba">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">INDUSTRY SOLUTIONS</h5>
                                    <p class="card-text">In industries, automation, security, and energy efficiency are critical for smooth operations and safeguarding assets. NYSTAI’s industrial solutions integrate CCTV cameras, alarms, and automation systems into a wired setup, ensuring reliable performance in large-scale environments. Coupled with solar-powered options, our solutions not only enhance security but also improve energy efficiency and sustainability. With real-time monitoring and proactive systems, businesses can maintain control, prevent issues, and optimize their operations, all from a central platform.</p>
                                    <Link to="https://nystai.com/#/nystai-solution-Industrial" target="_blank"><button>View More</button></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="down-contents-adhiba">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">HOME AUTOMATION</h5>
                                    <p class="card-text">Home automation has become essential for modern living, offering convenience, security, and peace of mind. With smart home products like CCTV cameras, alarms, and automation systems, homeowners can monitor their properties and control various aspects of their homes with ease. NYSTAI’s home automation solutions combine these functions into one seamless system, ensuring maximum security and efficiency. This integrated approach provides users with real-time updates and proactive monitoring, making homes smarter and safer.</p>
                                    <Link to="https://nystai.com/#/nystai-solution-home" target="_blank"><button>View More</button></Link>
                                </div>
                            </div>
                        </div>
                        <div style={{ marginTop: "2.5%" }}>
                            <img src={soluimg3} className="img-fluid w-100 rounded-2 left-right-images-adhiba" />
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-lg-6">
                        <div style={{ marginBottom: "2.5%" }}>
                            <img src={soluimg4} className="img-fluid w-100 rounded-2 left-right-images-adhiba" />
                        </div>
                        <div className="down-contents-adhiba">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">AI VMS</h5>
                                    <p class="card-text">Nystai’s Vehicle Management Systems (VMS) offer cutting-edge solutions for fleet monitoring and driver safety. With advanced technologies like dashboard cameras, AI-powered MDVR (Mobile Digital Video Recorder), and 360-degree camera monitors, businesses can ensure comprehensive vehicle surveillance and real-time data collection. These systems provide valuable insights into driver behavior, accident prevention, and operational efficiency, while enhancing security. Whether used in logistics, transportation, or industrial settings, Our VMS improves vehicle oversight, helping companies reduce risks, enhance safety, and optimize performance. The combination of AI analytics and visual monitoring makes it an essential tool for managing fleets efficiently and safely.</p>
                                    <Link to="https://nystai.com/#/nystai-solution-vms" target="_blank"><button>View More</button></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="down-contents-adhiba">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">EDUCATION</h5>
                                    <p class="card-text">NYSTAI's Interactive Flat-Panel Display (IFPD) offers an adaptable solution for educational institutions and industries. This versatile panel allows users to install their preferred devices and displays, ensuring a customized experience. Designed for seamless integration, the IFPD enhances interactive learning and workplace collaboration by providing a flexible platform that fits diverse needs. With its ultra-clear display and sleek design, NYSTAI's IFPD allows users to combine multiple tools into one, fostering more dynamic and engaging environments. Whether in a classroom or boardroom, the IFPD provides the foundation for smoother, more efficient interactions, revolutionizing both learning and business communication.</p>
                                    <Link to="https://nystai.com/#/nystai-solution-education" target="_blank"><button>View More</button></Link>
                                </div>
                            </div>
                        </div>
                        <div style={{ marginTop: "2.5%" }}>
                            <img src={soluimg5} className="img-fluid w-100 rounded-2 left-right-images-adhiba" />
                        </div>
                    </div>
                </div>

                <div className="row mt-4 ">
                    <div className="col-lg-6 order-sm-2">
                        <div style={{ marginBottom: "2.5%" }}>
                            <img src={soluimg6} className="img-fluid w-100 rounded-2 left-right-images-adhiba" />
                        </div>
                        <div className="down-contents-adhiba">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">HOSPITAL SOLUTION</h5>
                                    <p class="card-text">The NYSTAI product offers cutting-edge healthcare solutions to address the technological challenges faced by hospitals. With advanced patient monitoring systems, AI-powered diagnostic tools, and seamless communication platforms, NYSTAI enhances patient care and improves operational efficiency. It integrates telemedicine for remote consultations and streamlines the management of electronic health records (EHR), ensuring accuracy and easy access to patient data. By modernizing hospital technology, NYSTAI empowers healthcare teams to deliver better, faster care while reducing administrative burdens. This all-in-one solution is designed to optimize hospital workflows and support proactive, data-driven medical decisions.</p>
                                    <Link to="https://nystai.com/#/nystai-solution-Hospital" target="_blank"><button>View More</button></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 order-sm-1">
                        <div className="down-contents-adhiba">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">WAREHOUSE SOLUTIONS</h5>
                                    <p class="card-text">In warehouses, safety is paramount as heavy machinery and fast-paced operations pose risks to workers and equipment. NYSTAI’s warehouse solutions offer essential products like anti-collision devices, forklift safety lights, alert systems, cameras, and 4G helmets with walkie-talkies. These solutions enhance visibility, communication, and accident prevention, ensuring safer and more efficient work environments. Additionally, emergency lights and virtual signage provide crucial guidance in emergencies, improving overall safety protocols. By integrating these technologies, warehouses can minimize accidents and optimize their operations.</p>
                                    <Link to="https://nystai.com/#/nystai-solution-Warehouse" target="_blank"> <button>View More</button></Link>
                                </div>
                            </div>
                        </div>
                        <div style={{ marginTop: "2.5%" }}>
                            <img src={soluimg7} className="img-fluid w-100 rounded-2 left-right-images-adhiba" />
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-lg-6">
                        <div style={{ marginBottom: "2.5%" }}>
                            <img src={soluimg8} className="img-fluid w-100 rounded-2 left-right-images-adhiba" />
                        </div>
                        {/* <div className="down-contents-adhiba">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">HOSPITAL SOLUTION</h5>
                                    <p class="card-text">The NYSTAI product offers cutting-edge healthcare solutions to address the technological challenges faced by hospitals. With advanced patient monitoring systems, AI-powered diagnostic tools, and seamless communication platforms, NYSTAI enhances patient care and improves operational efficiency. It integrates telemedicine for remote consultations and streamlines the management of electronic health records (EHR), ensuring accuracy and easy access to patient data. By modernizing hospital technology, NYSTAI empowers healthcare teams to deliver better, faster care while reducing administrative burdens. This all-in-one solution is designed to optimize hospital workflows and support proactive, data-driven medical decisions.</p>
                                    <button>View More</button>
                                </div>
                            </div>
                        </div> */}
                    </div>
                    <div className="col-lg-6">
                        <div className="down-contents-adhiba">
                            <div class="card">
                                <div class="card-body">
                                    <h5 class="card-title">PARKING IOT SOLUTION</h5>
                                    <p class="card-text">INystai’s Traffic Management Intelligent AI Parking Solutions provide advanced technologies to optimize parking and traffic flow. Our product lineup includes ANPR cameras, ultrasonic sensors, and integrated camera-light systems. These solutions automate vehicle identification, detect available parking spaces, and manage traffic congestion, creating a seamless parking experience. Nystai's AI-powered systems enhance safety, streamline traffic management, and improve overall parking efficiency, reducing human intervention.</p>
                                    <Link to="https://nystai.com/#/nystai-solution-parking" target="_blank"><button>View More</button></Link>
                                </div>
                            </div>
                        </div>
                        {/* <div style={{ marginTop: "2.5%" }}>
                            <img src={soluimg7} className="img-fluid w-100 rounded-2 left-right-images-adhiba" />
                        </div> */}
                    </div>
                </div>


            </div>


            {/* READY TO GO */}
            <section className="ready-to-go-section-adhiba">
                <div className="container">
                    <div className="ready-to-go-heading-adhiba">
                        <h3>READY TO GO ? WE GOT YOU</h3>
                        <p>We are ready to deliver our trusted solutions, offering reliable, high-quality products and services to meet your needs. With <br /> our expertise and commitment to excellence, we ensure that every customer receives the best-in-class solutions for ultimate <br /> satisfaction and security.</p>
                    </div>
                    <div className="ready-to-go-button-adhiba">
                        <Link to="/adhiba-support">   <button className="mt-3">Contact Us</button></Link>
                    </div>
                </div>
            </section>


            {/* TESTIMONIAL */}
            <Testimonial />

            <Footer />

        </>
    );
}

